module.exports = __webpack_public_path__ + "img/karagandy3.55aecdfc.jpg";